import { Helmet } from "react-helmet-async";

const categoryTitles = {
  live: "Live Games",
  casino: "Casino Games",
  card: "Card Games",
  table: "Table & Board Games",
};

export default function MetaTitle({ category, customTitle }) {
  const pageTitle =
    customTitle || categoryTitles[category?.toLowerCase()] || "Home";

  const hostname = window.location.hostname;
  // console.log("hostname", hostname)

  return (
    <Helmet>
      {hostname === "demo.utwebapps.com" ? (
        <link rel="icon" href="/favicon_demo.svg" />
      ) : hostname === "testing-rumblebets.utwebapps.com" ? (
        <link rel="icon" href="/favicon_testing.svg" />
      ) : (
        <link rel="icon" href="/favicon_testing.svg" />
      )}

      <title>
        {pageTitle} -{" "}

        {hostname === "demo.utwebapps.com" ? (
          "Casino Nest"
        ) : hostname === "testing-rumblebets.utwebapps.com" ? (
          "Rumblebets"
        ) : "Rumblebets"}

      </title>

      <meta
        name="description"
        content={`Play exciting ${pageTitle} on Casino Nest!`}
      />
    </Helmet>
  );
}
